/* eslint-disable */
import { Timestamp } from "../../google/protobuf/timestamp";
import { App_Source, app_SourceFromJSON, app_SourceToJSON } from "../common/common";

export const protobufPackage = "api.customers";

export interface Customer {
  /** `SA_User_Records`.`uid` */
  guid: string;
  /** 帳號來源: lativ */
  source: App_Source;
  /** 帳號類型. `SA_User_Records`.`provider` */
  provider: Customer_Provider;
  /** 會員編號 */
  friendlyId: string;
  /** 註冊時間 */
  createTime:
    | Date
    | undefined;
  /** 姓名 */
  name: string;
  /** 頭像 */
  photoUrl: string;
  /** 註冊手機號碼 */
  phoneNumber: string;
  /** Email */
  email: string;
  /** 載具ID */
  carrierId: string;
  /** 載具檢查碼 */
  carrierVerifyCode: string;
  /** 廣告參數 */
  adId: string;
  /** 更新時間 */
  updateTime: Date | undefined;
}

/** 帳號類型 */
export enum Customer_Provider {
  PROVIDER_EMAIL = 0,
  PROVIDER_PHONE = 1,
  PROVIDER_FACEBOOK = 2,
  PROVIDER_APPLE = 3,
  /** PROVIDER_LEGACY - 舊系統會員 */
  PROVIDER_LEGACY = 10,
}

export function customer_ProviderFromJSON(object: any): Customer_Provider {
  switch (object) {
    case 0:
    case "PROVIDER_EMAIL":
      return Customer_Provider.PROVIDER_EMAIL;
    case 1:
    case "PROVIDER_PHONE":
      return Customer_Provider.PROVIDER_PHONE;
    case 2:
    case "PROVIDER_FACEBOOK":
      return Customer_Provider.PROVIDER_FACEBOOK;
    case 3:
    case "PROVIDER_APPLE":
      return Customer_Provider.PROVIDER_APPLE;
    case 10:
    case "PROVIDER_LEGACY":
      return Customer_Provider.PROVIDER_LEGACY;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Customer_Provider");
  }
}

export function customer_ProviderToJSON(object: Customer_Provider): string {
  switch (object) {
    case Customer_Provider.PROVIDER_EMAIL:
      return "PROVIDER_EMAIL";
    case Customer_Provider.PROVIDER_PHONE:
      return "PROVIDER_PHONE";
    case Customer_Provider.PROVIDER_FACEBOOK:
      return "PROVIDER_FACEBOOK";
    case Customer_Provider.PROVIDER_APPLE:
      return "PROVIDER_APPLE";
    case Customer_Provider.PROVIDER_LEGACY:
      return "PROVIDER_LEGACY";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Customer_Provider");
  }
}

/** 帳號狀態 */
export enum Customer_State {
  STATE_UNSPECIFIED = 0,
  /** STATE_NORMAL - 使用中 */
  STATE_NORMAL = 1,
  /** STATE_SUSPENDED - 停權中 */
  STATE_SUSPENDED = 2,
}

export function customer_StateFromJSON(object: any): Customer_State {
  switch (object) {
    case 0:
    case "STATE_UNSPECIFIED":
      return Customer_State.STATE_UNSPECIFIED;
    case 1:
    case "STATE_NORMAL":
      return Customer_State.STATE_NORMAL;
    case 2:
    case "STATE_SUSPENDED":
      return Customer_State.STATE_SUSPENDED;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Customer_State");
  }
}

export function customer_StateToJSON(object: Customer_State): string {
  switch (object) {
    case Customer_State.STATE_UNSPECIFIED:
      return "STATE_UNSPECIFIED";
    case Customer_State.STATE_NORMAL:
      return "STATE_NORMAL";
    case Customer_State.STATE_SUSPENDED:
      return "STATE_SUSPENDED";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum Customer_State");
  }
}

export interface BalanceRecord {
  id: string;
  /** 虛帳使用類型 */
  type: BalanceRecord_Type;
  /** 顧客guid */
  customerGuid: string;
  /** 存入金額/支出金額 */
  amount: string;
  /** 異動前結餘 */
  prevBalance: string;
  /** 異動後結餘 */
  balance: string;
  /** 建立時間 */
  createTime:
    | Date
    | undefined;
  /** 訂單編號 */
  orderSourceId: string;
  /** 結清資料id */
  settlementRecordId: string;
  /** 結清資料, 只有申請結清會有資料 */
  settlementRecord: SettlementRecord | undefined;
}

export enum BalanceRecord_Type {
  TYPE_UNSPECIFIED = 0,
  /** TYPE_ORDER_DEDUCTION - 訂單折抵 */
  TYPE_ORDER_DEDUCTION = 1,
  /** TYPE_ORDER_DEDUCTION_CANCELED - 訂單折抵取消 */
  TYPE_ORDER_DEDUCTION_CANCELED = 2,
  /** TYPE_RETURNS_CREDITED - 退貨入帳 */
  TYPE_RETURNS_CREDITED = 3,
  /** TYPE_APPLIED_SETTLEMENT - 申請結清 */
  TYPE_APPLIED_SETTLEMENT = 4,
  /** TYPE_APPLIED_SETTLEMENT_CANCELED - 申請結清取消 */
  TYPE_APPLIED_SETTLEMENT_CANCELED = 5,
}

export function balanceRecord_TypeFromJSON(object: any): BalanceRecord_Type {
  switch (object) {
    case 0:
    case "TYPE_UNSPECIFIED":
      return BalanceRecord_Type.TYPE_UNSPECIFIED;
    case 1:
    case "TYPE_ORDER_DEDUCTION":
      return BalanceRecord_Type.TYPE_ORDER_DEDUCTION;
    case 2:
    case "TYPE_ORDER_DEDUCTION_CANCELED":
      return BalanceRecord_Type.TYPE_ORDER_DEDUCTION_CANCELED;
    case 3:
    case "TYPE_RETURNS_CREDITED":
      return BalanceRecord_Type.TYPE_RETURNS_CREDITED;
    case 4:
    case "TYPE_APPLIED_SETTLEMENT":
      return BalanceRecord_Type.TYPE_APPLIED_SETTLEMENT;
    case 5:
    case "TYPE_APPLIED_SETTLEMENT_CANCELED":
      return BalanceRecord_Type.TYPE_APPLIED_SETTLEMENT_CANCELED;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum BalanceRecord_Type");
  }
}

export function balanceRecord_TypeToJSON(object: BalanceRecord_Type): string {
  switch (object) {
    case BalanceRecord_Type.TYPE_UNSPECIFIED:
      return "TYPE_UNSPECIFIED";
    case BalanceRecord_Type.TYPE_ORDER_DEDUCTION:
      return "TYPE_ORDER_DEDUCTION";
    case BalanceRecord_Type.TYPE_ORDER_DEDUCTION_CANCELED:
      return "TYPE_ORDER_DEDUCTION_CANCELED";
    case BalanceRecord_Type.TYPE_RETURNS_CREDITED:
      return "TYPE_RETURNS_CREDITED";
    case BalanceRecord_Type.TYPE_APPLIED_SETTLEMENT:
      return "TYPE_APPLIED_SETTLEMENT";
    case BalanceRecord_Type.TYPE_APPLIED_SETTLEMENT_CANCELED:
      return "TYPE_APPLIED_SETTLEMENT_CANCELED";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum BalanceRecord_Type");
  }
}

export interface SettlementRecord {
  id: string;
  /** 狀態 */
  state: SettlementRecord_State;
  /** 顧客guid */
  customerGuid: string;
  /** 結清金額 */
  amount: string;
  /** 戶名 */
  name: string;
  /** 銀行代碼 */
  bankCode: string;
  /** 銀行名稱 */
  bankName: string;
  /** 匯款帳戶 */
  remittanceAccount: string;
  /** 建立時間(申請時間) */
  createTime: Date | undefined;
}

export enum SettlementRecord_State {
  STATE_UNSPECIFIED = 0,
  /** STATE_APPLIED - 已申請 */
  STATE_APPLIED = 1,
  /** STATE_CREDITED - 已入帳 */
  STATE_CREDITED = 2,
  /** STATE_CANCELED - 已取消/失敗 */
  STATE_CANCELED = 3,
}

export function settlementRecord_StateFromJSON(object: any): SettlementRecord_State {
  switch (object) {
    case 0:
    case "STATE_UNSPECIFIED":
      return SettlementRecord_State.STATE_UNSPECIFIED;
    case 1:
    case "STATE_APPLIED":
      return SettlementRecord_State.STATE_APPLIED;
    case 2:
    case "STATE_CREDITED":
      return SettlementRecord_State.STATE_CREDITED;
    case 3:
    case "STATE_CANCELED":
      return SettlementRecord_State.STATE_CANCELED;
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SettlementRecord_State");
  }
}

export function settlementRecord_StateToJSON(object: SettlementRecord_State): string {
  switch (object) {
    case SettlementRecord_State.STATE_UNSPECIFIED:
      return "STATE_UNSPECIFIED";
    case SettlementRecord_State.STATE_APPLIED:
      return "STATE_APPLIED";
    case SettlementRecord_State.STATE_CREDITED:
      return "STATE_CREDITED";
    case SettlementRecord_State.STATE_CANCELED:
      return "STATE_CANCELED";
    default:
      throw new tsProtoGlobalThis.Error("Unrecognized enum value " + object + " for enum SettlementRecord_State");
  }
}

function createBaseCustomer(): Customer {
  return {
    guid: "",
    source: 0,
    provider: 0,
    friendlyId: "",
    createTime: undefined,
    name: "",
    photoUrl: "",
    phoneNumber: "",
    email: "",
    carrierId: "",
    carrierVerifyCode: "",
    adId: "",
    updateTime: undefined,
  };
}

export const Customer = {
  fromJSON(object: any): Customer {
    return {
      guid: isSet(object.guid) ? String(object.guid) : "",
      source: isSet(object.source) ? app_SourceFromJSON(object.source) : 0,
      provider: isSet(object.provider) ? customer_ProviderFromJSON(object.provider) : 0,
      friendlyId: isSet(object.friendlyId) ? String(object.friendlyId) : "",
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      name: isSet(object.name) ? String(object.name) : "",
      photoUrl: isSet(object.photoUrl) ? String(object.photoUrl) : "",
      phoneNumber: isSet(object.phoneNumber) ? String(object.phoneNumber) : "",
      email: isSet(object.email) ? String(object.email) : "",
      carrierId: isSet(object.carrierId) ? String(object.carrierId) : "",
      carrierVerifyCode: isSet(object.carrierVerifyCode) ? String(object.carrierVerifyCode) : "",
      adId: isSet(object.adId) ? String(object.adId) : "",
      updateTime: isSet(object.updateTime) ? fromJsonTimestamp(object.updateTime) : undefined,
    };
  },

  toJSON(message: Customer): unknown {
    const obj: any = {};
    message.guid !== undefined && (obj.guid = message.guid);
    message.source !== undefined && (obj.source = app_SourceToJSON(message.source));
    message.provider !== undefined && (obj.provider = customer_ProviderToJSON(message.provider));
    message.friendlyId !== undefined && (obj.friendlyId = message.friendlyId);
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.name !== undefined && (obj.name = message.name);
    message.photoUrl !== undefined && (obj.photoUrl = message.photoUrl);
    message.phoneNumber !== undefined && (obj.phoneNumber = message.phoneNumber);
    message.email !== undefined && (obj.email = message.email);
    message.carrierId !== undefined && (obj.carrierId = message.carrierId);
    message.carrierVerifyCode !== undefined && (obj.carrierVerifyCode = message.carrierVerifyCode);
    message.adId !== undefined && (obj.adId = message.adId);
    message.updateTime !== undefined && (obj.updateTime = message.updateTime.toISOString());
    return obj;
  },

  create<I extends Exact<DeepPartial<Customer>, I>>(base?: I): Customer {
    return Customer.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<Customer>, I>>(object: I): Customer {
    const message = createBaseCustomer();
    message.guid = object.guid ?? "";
    message.source = object.source ?? 0;
    message.provider = object.provider ?? 0;
    message.friendlyId = object.friendlyId ?? "";
    message.createTime = object.createTime ?? undefined;
    message.name = object.name ?? "";
    message.photoUrl = object.photoUrl ?? "";
    message.phoneNumber = object.phoneNumber ?? "";
    message.email = object.email ?? "";
    message.carrierId = object.carrierId ?? "";
    message.carrierVerifyCode = object.carrierVerifyCode ?? "";
    message.adId = object.adId ?? "";
    message.updateTime = object.updateTime ?? undefined;
    return message;
  },
};

function createBaseBalanceRecord(): BalanceRecord {
  return {
    id: "",
    type: 0,
    customerGuid: "",
    amount: "",
    prevBalance: "",
    balance: "",
    createTime: undefined,
    orderSourceId: "",
    settlementRecordId: "",
    settlementRecord: undefined,
  };
}

export const BalanceRecord = {
  fromJSON(object: any): BalanceRecord {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      type: isSet(object.type) ? balanceRecord_TypeFromJSON(object.type) : 0,
      customerGuid: isSet(object.customerGuid) ? String(object.customerGuid) : "",
      amount: isSet(object.amount) ? String(object.amount) : "",
      prevBalance: isSet(object.prevBalance) ? String(object.prevBalance) : "",
      balance: isSet(object.balance) ? String(object.balance) : "",
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
      orderSourceId: isSet(object.orderSourceId) ? String(object.orderSourceId) : "",
      settlementRecordId: isSet(object.settlementRecordId) ? String(object.settlementRecordId) : "",
      settlementRecord: isSet(object.settlementRecord) ? SettlementRecord.fromJSON(object.settlementRecord) : undefined,
    };
  },

  toJSON(message: BalanceRecord): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.type !== undefined && (obj.type = balanceRecord_TypeToJSON(message.type));
    message.customerGuid !== undefined && (obj.customerGuid = message.customerGuid);
    message.amount !== undefined && (obj.amount = message.amount);
    message.prevBalance !== undefined && (obj.prevBalance = message.prevBalance);
    message.balance !== undefined && (obj.balance = message.balance);
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    message.orderSourceId !== undefined && (obj.orderSourceId = message.orderSourceId);
    message.settlementRecordId !== undefined && (obj.settlementRecordId = message.settlementRecordId);
    message.settlementRecord !== undefined &&
      (obj.settlementRecord = message.settlementRecord ? SettlementRecord.toJSON(message.settlementRecord) : undefined);
    return obj;
  },

  create<I extends Exact<DeepPartial<BalanceRecord>, I>>(base?: I): BalanceRecord {
    return BalanceRecord.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<BalanceRecord>, I>>(object: I): BalanceRecord {
    const message = createBaseBalanceRecord();
    message.id = object.id ?? "";
    message.type = object.type ?? 0;
    message.customerGuid = object.customerGuid ?? "";
    message.amount = object.amount ?? "";
    message.prevBalance = object.prevBalance ?? "";
    message.balance = object.balance ?? "";
    message.createTime = object.createTime ?? undefined;
    message.orderSourceId = object.orderSourceId ?? "";
    message.settlementRecordId = object.settlementRecordId ?? "";
    message.settlementRecord = (object.settlementRecord !== undefined && object.settlementRecord !== null)
      ? SettlementRecord.fromPartial(object.settlementRecord)
      : undefined;
    return message;
  },
};

function createBaseSettlementRecord(): SettlementRecord {
  return {
    id: "",
    state: 0,
    customerGuid: "",
    amount: "",
    name: "",
    bankCode: "",
    bankName: "",
    remittanceAccount: "",
    createTime: undefined,
  };
}

export const SettlementRecord = {
  fromJSON(object: any): SettlementRecord {
    return {
      id: isSet(object.id) ? String(object.id) : "",
      state: isSet(object.state) ? settlementRecord_StateFromJSON(object.state) : 0,
      customerGuid: isSet(object.customerGuid) ? String(object.customerGuid) : "",
      amount: isSet(object.amount) ? String(object.amount) : "",
      name: isSet(object.name) ? String(object.name) : "",
      bankCode: isSet(object.bankCode) ? String(object.bankCode) : "",
      bankName: isSet(object.bankName) ? String(object.bankName) : "",
      remittanceAccount: isSet(object.remittanceAccount) ? String(object.remittanceAccount) : "",
      createTime: isSet(object.createTime) ? fromJsonTimestamp(object.createTime) : undefined,
    };
  },

  toJSON(message: SettlementRecord): unknown {
    const obj: any = {};
    message.id !== undefined && (obj.id = message.id);
    message.state !== undefined && (obj.state = settlementRecord_StateToJSON(message.state));
    message.customerGuid !== undefined && (obj.customerGuid = message.customerGuid);
    message.amount !== undefined && (obj.amount = message.amount);
    message.name !== undefined && (obj.name = message.name);
    message.bankCode !== undefined && (obj.bankCode = message.bankCode);
    message.bankName !== undefined && (obj.bankName = message.bankName);
    message.remittanceAccount !== undefined && (obj.remittanceAccount = message.remittanceAccount);
    message.createTime !== undefined && (obj.createTime = message.createTime.toISOString());
    return obj;
  },

  create<I extends Exact<DeepPartial<SettlementRecord>, I>>(base?: I): SettlementRecord {
    return SettlementRecord.fromPartial(base ?? {});
  },

  fromPartial<I extends Exact<DeepPartial<SettlementRecord>, I>>(object: I): SettlementRecord {
    const message = createBaseSettlementRecord();
    message.id = object.id ?? "";
    message.state = object.state ?? 0;
    message.customerGuid = object.customerGuid ?? "";
    message.amount = object.amount ?? "";
    message.name = object.name ?? "";
    message.bankCode = object.bankCode ?? "";
    message.bankName = object.bankName ?? "";
    message.remittanceAccount = object.remittanceAccount ?? "";
    message.createTime = object.createTime ?? undefined;
    return message;
  },
};

declare var self: any | undefined;
declare var window: any | undefined;
declare var global: any | undefined;
var tsProtoGlobalThis: any = (() => {
  if (typeof globalThis !== "undefined") {
    return globalThis;
  }
  if (typeof self !== "undefined") {
    return self;
  }
  if (typeof window !== "undefined") {
    return window;
  }
  if (typeof global !== "undefined") {
    return global;
  }
  throw "Unable to locate global object";
})();

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends Array<infer U> ? Array<DeepPartial<U>> : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function fromTimestamp(t: Timestamp): Date {
  let millis = (t.seconds || 0) * 1_000;
  millis += (t.nanos || 0) / 1_000_000;
  return new Date(millis);
}

function fromJsonTimestamp(o: any): Date {
  if (o instanceof Date) {
    return o;
  } else if (typeof o === "string") {
    return new Date(o);
  } else {
    return fromTimestamp(Timestamp.fromJSON(o));
  }
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
